<!-- 快速查件 -->
<template>
<el-container>
  <el-main>
    <el-row style="padding: 10px 20px;">
      <el-col :xs="24" :sm="10">
          <el-input v-model="code" @keyup.native="autoSave" ref="codeRef" :placeholder="msg('请输入单号')" 
              size="medium">
          <el-button slot="append" icon="el-icon-search" @click="doCheck">查询</el-button>
          </el-input>
      </el-col>
   </el-row>
   <el-form label-width="100px" label-position="right">
    <template v-if="stock">
    <div style="background-color:#DCDFE6;box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)"><span><h2>出货信息</h2></span></div>
      <el-row>
        <el-col :xs="18" :sm="6">
          <el-form-item label="订单编号：">
            <span class="id-cell">{{stock.code}}<i class="detail-cell el-icon-view" @click="openDetail(stock.id)"></i></span>
          </el-form-item>
        </el-col>
        <el-col :xs="18" :sm="6">
          <el-form-item label="查询码：">
            {{stock.expCode}}
          </el-form-item>
        </el-col>
        <el-col :xs="18" :sm="6">
          <el-form-item label="面单码：">
            {{stock.expPageCode}}
          </el-form-item>
        </el-col>
        <el-col :xs="18" :sm="6">
            <el-form-item label="运输方式：">
              {{stock.transport}}
            </el-form-item>
          </el-col>
      </el-row>
      <el-row>
          <el-col :xs="18" :sm="6">
            <el-form-item label="袋号：">
              {{stock.expPkgCode}}
            </el-form-item>
          </el-col>
          <el-col :xs="18" :sm="6">
            <el-form-item label="仓库：">
              {{stock.storeName}}
            </el-form-item>
          </el-col>
          <el-col :xs="18" :sm="6">
            <el-form-item label="归属人：">
              {{stock.createrName}}
            </el-form-item>
          </el-col>
          <el-col :xs="18" :sm="6">
            <el-form-item label="归属公司：">
              {{stock.company}}
            </el-form-item>
          </el-col>
      </el-row>
      <el-row>
          <el-col :xs="18" :sm="6">
            <el-form-item label="订单来源：">
              {{stock.orderOrigin}}
            </el-form-item>
          </el-col>
          <el-col :xs="18" :sm="6">
            <el-form-item label="配送方式：">
              {{stock.expCompany}}
            </el-form-item>
          </el-col>
          <el-col :xs="18" :sm="6">
            <el-form-item label="货态：">
              {{stock.status}}
            </el-form-item>
          </el-col>
          <el-col :xs="18" :sm="6">
            <el-form-item label="打包类型：">
              {{stock.expPkgType}}
            </el-form-item>
          </el-col>
      </el-row>
      <el-row>
          <el-col :xs="18" :sm="6">
            <el-form-item label="订单金额：">
              {{stock.amtOrder>0?(stock.amtOrder*0.01).toFixed(2):0}}
            </el-form-item>
          </el-col>
          <el-col :xs="18" :sm="6">
            <el-form-item label="配送类型：">
              {{stock.expCod==1?'货到付款':'纯配送'}}
            </el-form-item>
          </el-col>
          <el-col :xs="18" :sm="6">
            <el-form-item label="代收金额：">
              {{stock.offlineAmount>0?(stock.offlineAmount*0.01).toFixed(2):0}}
            </el-form-item>
          </el-col>
      </el-row>
      <el-row>
        <el-col :xs="24" :sm="12">
          <div v-if="data" class="ctrl-panel">
            <div class="trace-wrap">
                <div class="trace-box">
                    <h4>{{msg('物流状态跟踪')}}</h4>
                    <el-timeline :reverse="true">
                        <el-timeline-item
                            type="danger"
                            v-for="(item, index) in data.statuses" :key="index"
                            :timestamp="item.created">
                                {{item.createrName}} : {{item.ctrl}} - {{item.label}}-{{item.remark}}
                        </el-timeline-item>
                    </el-timeline>
                </div>
                <div>
                    <h4>{{msg("台湾物流状态跟踪")}}</h4>
                    <el-timeline :reverse="true">
                        <el-timeline-item
                            type="danger"
                            v-for="(item, index) in data.twExpTracks" :key="index"
                            :timestamp="item.created">
                                {{item.remark}}
                        </el-timeline-item>
                    </el-timeline>
                </div>
            </div>
            <h4>{{msg('国内物流详情')}}</h4>
            <div class="details">
                <div class="detail">
                    <span>{{data.code}}</span>
                    <a target="_blank" :href="'https://www.baidu.com/s?wd='+data.code">{{msg("点击查看物流")}}</a>
                </div>
                <span v-for="(item, idx) in data.details" :key="idx">
                    <div class="detail" v-if="item.innerExpCode">
                        <span>{{item.innerExpCode}}({{item.shelfCode}})</span>
                        <a target="_blank" :href="'https://www.baidu.com/s?wd='+item.innerExpCode">{{msg("点击查看物流")}}</a>
                    </div>
                </span>
            </div>
          </div>
        </el-col>
      </el-row>
    </template>
    <template v-if="inventory">
    <div style="background-color:#DCDFE6;box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)"><span><h2>库存信息</h2></span></div>
      <el-row>
        <el-col :xs="18" :sm="6">
          <el-form-item label="库存编号：">
            {{inventory.code}}
          </el-form-item>
        </el-col>
        <el-col :xs="18" :sm="6">
          <el-form-item label="所在仓库：">
            {{inventory.storeName}}
          </el-form-item>
        </el-col>
        <el-col :xs="18" :sm="6">
          <el-form-item label="架位号：">
            {{inventory.shelfCode}}
          </el-form-item>
        </el-col>
        <el-col :xs="18" :sm="6">
          <el-form-item label="仓储类型：">
            {{inventory.storeType}}
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :xs="18" :sm="6">
          <el-form-item label="入仓时间：">
            {{inventory.inTime}}
          </el-form-item>
        </el-col>
        <el-col :xs="18" :sm="6">
          <el-form-item label="保管期限：">
            {{inventory.expExpireDate}}
          </el-form-item>
        </el-col>
        <el-col :xs="18" :sm="6">
          <el-form-item label="归属人：">
            {{inventory.ownerName}}
          </el-form-item>
        </el-col>
        <el-col :xs="18" :sm="6">
          <el-form-item label="归属公司：">
            {{inventory.companyName}}
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-table border :data="inventoryTable" style="width: 50%" max-height="400">
          <el-table-column prop="subCode" label="子编号" min-width="150"></el-table-column>
          <el-table-column prop="status" label="仓储状态" min-width="120">
            <template slot-scope="scope">
                <!-- <el-tag :type="dicts.inventoryStatuses.find(d => d.value === scope.row.status).type" disable-transitions>
                    {{dicts.inventoryStatuses.find(d => d.value === scope.row.status).label}}</el-tag> -->
                <i class="detail-cell iconfont icon-trace font11" @click="inventoryInOutTraces(scope.row.id,scope.row.code)"></i>
                <el-button size="mini" plain style="cursor: pointer;" 
                    @click="inventoryTraces(scope.row.id,scope.row.code)"
                    :type="dicts.inventoryStatuses.find(d => d.value === scope.row.status).type">
                    {{dicts.inventoryStatuses.find(d => d.value === scope.row.status).label}}
                </el-button>
            </template>
          </el-table-column>
          <el-table-column prop="qty" label="可用数量" min-width="120"></el-table-column>
        </el-table>
      </el-row>
      </template>
      <template v-if="inventoryIn">
        <div style="background-color:#DCDFE6;box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)"><span><h2>采购信息</h2></span></div>
        <el-row>
          <el-col :xs="18" :sm="6">
            <el-form-item label="快递单号：">
              <span class="id-cell">{{inventoryIn.expCode}}<i class="detail-cell iconfont icon-trace font11" @click="openInventoryInDetail(inventoryIn.expCode)"></i><a target="_blank" :href="'https://www.baidu.com/s?wd='+inventoryIn.expCode"><i class="el-icon-link"></i></a></span>
            </el-form-item>
          </el-col>
          <el-col :xs="18" :sm="6">
            <el-form-item label="配送天数：">
              {{inventoryIn.durationDay}}
            </el-form-item>
          </el-col>
          <el-col :xs="18" :sm="6">
            <el-form-item label="采购状态：">
              {{inventoryIn.status}}
            </el-form-item>
          </el-col>
          <el-col :xs="18" :sm="6">
            <el-form-item label="到货仓库：">
              {{inventoryIn.storeName}}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :xs="18" :sm="6">
            <el-form-item label="归属人：">
              {{inventoryIn.ownerName}}
            </el-form-item>
          </el-col>
          <el-col :xs="18" :sm="6">
            <el-form-item label="归属公司：">
              {{inventoryIn.ownerCompanyName}}
            </el-form-item>
          </el-col>
          <el-col :xs="18" :sm="6">
            <el-form-item label="录单时间：">
              {{inventoryIn.created}}
            </el-form-item>
          </el-col>
          <el-col :xs="18" :sm="6">
            <el-form-item label="签收时间：">
              {{inventoryIn.receiveDate}}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <h3>库存采购单变化详情</h3>
            <div>{{ inventoryIn.purchaseCode?  "采购单号： " + inventoryIn.purchaseCode:''  }}</div>
            <div style="padding-top:6px;padding-bottom:10px;">{{ inventoryIn.expCode?  "快递单号： " + inventoryIn.expCode:''  }}</div>
            <div class="trace-wrap" style="margin-left:-35px;">
                <div class="trace-box">
                    <el-timeline >
                        <el-timeline-item
                            type="danger"
                            v-for="(item, index) in inventoryInTraces" :key="index"
                            :timestamp="item.created">
                                {{item.createrName}} : {{item.ctrl}} - {{item.label}}-{{item.remark}}
                        </el-timeline-item>
                    </el-timeline>
                </div>
            </div>
        </el-row>
      </template>
      <template v-if="checkHists && checkHists.length > 0">
        <div style="background-color:#DCDFE6;box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)"><span><h2>核单信息</h2></span></div>
        <el-row>
          <el-table :data="checkHists" style="width: 70%" max-height="400">
            <el-table-column prop="created" label="操作时间" min-width="150"></el-table-column>
            <el-table-column prop="code1" label="单号" min-width="120"></el-table-column>
            <el-table-column prop="storeName" label="仓库" min-width="120"></el-table-column>
            <el-table-column prop="ownerName" label="操作人" min-width="120"></el-table-column>
            <el-table-column prop="remark" label="备注" min-width="120"></el-table-column>
          </el-table>
        </el-row>
      </template>
    </el-form>
  </el-main>

  <!-- 状态记录 -->
  <inventory-trace ref="inventoryTraceRef"/>
  <!-- 入库出库记录 -->
  <inventory-out-trace ref="inventoryOutTraceRef"/>
  <inventory-in-order-trace ref="inventoryInOrderTraceRef"/>

  <div style="display:inline-block; width:1px; height:1px; overflow:hidden;">
      <audio controls="controls" preload ref="audioRef" >
      </audio>
  </div>

</el-container>
</template> 

<script>
// @ is an alias to /src
import NoRecord from "../../assets/media/NoRecord.mp3"; //2-记录不存在
import InventoryTrace from "../inventory/InventoryTrace.vue";
import InventoryOutTrace from "../inventory/InventoryOutTrace.vue";
import InventoryInOrderTrace from "../inventory/InventoryInOrderTrace.vue"
export default {
  name: 'Document',
  components: {
    InventoryTrace: InventoryTrace,
    InventoryOutTrace: InventoryOutTrace,
    InventoryInOrderTrace:InventoryInOrderTrace
  },
  mounted:function(){
  },
  data(){
    return{
        visiable: false,
        videoUrl: null,
        videos: [], 
        docs: [],  
        data: null,
        code:null,
        stock:null,
        inventory:null,
        inventoryTable:[],
        inventoryIn:null,
        inventoryInTraces:[],
        checkHists:[],
        audioUrl:null,
    }
  }, 
  computed: {
    isMinScreen: {  //是否小屏幕，浏览器
        get() {
          return this.$store.state.isMinScreen;
        }
    },
    docHeight: {  //表格的高度
        get() {
          var height =  this.$store.state.docHeight;
          return height;
        }
    }
  },
  methods: {
      autoSave(e){
          if(e.keyCode == 13){
              this.doCheck();
          }
      },
      doCheck(){
        this.data = null;
        this.stock = null;
        this.inventory = null;
        this.inventoryTable = [];
        this.inventoryIn = null;
        this.inventoryInTraces = [];
        this.checkHists = [];
        this.$axios.post(this.$kit.api.stock.tracesNew+"?code="+this.code+"&hist=")
            .then((result) => {
                if(result.status){
                    let data = result.data;
                    this.data = data.dto;
                    this.stock = data.stock;
                    this.inventory = data.inventory;
                    this.inventoryTable = data.inventorys;
                    let inventoryIn = data.inventoryIn;
                    this.inventoryInTraces = data.inventoryInTraces;
                    this.checkHists = data.checkHists;
                    if(!this.stock && !this.inventory && !this.inventoryTable && !this.inventoryIn && !this.inventoryInTraces && !this.checkHists){
                      this.audioUrl = NoRecord;
                      this.playAudio();
                      this.$message(this.msg('记录不存在'));
                      return;
                    }
                    if(this.stock){
                        this.stock.orderOrigin = this.dicts.orderOrigin.find(d => d.value === this.stock.orderOrigin).label;
                        this.stock.status = this.dicts.stockStatus.find(d => d.value === this.stock.status).label;
                        this.stock.storeType = this.dicts.stockStoreType.find(d => d.value === this.stock.storeType).label;
                        this.stock.expPkgType = this.dicts.stockExpPkgType.find(d => d.value === this.stock.expPkgType).label;
                    }
                    if(this.inventory){
                        this.inventory.storeType = this.dicts.inventoryStoreTypes.find(d => d.value === this.inventory.storeType).label;
                    }
                    if(inventoryIn){
                      let status = inventoryIn.status;
                      let sendDate = inventoryIn.sendDate;
                      if(status == 10 && sendDate){  //已发货
                        let prevDate = new Date(sendDate);
                        let curr = new Date();
                        let day = Math.trunc((curr - prevDate) / (3600*24*1000));
                        inventoryIn.durationDay = day;
                      }else{
                        inventoryIn.durationDay = "";
                      }
                      inventoryIn.status = this.dicts.inventoryInStatus.find(d => d.value === inventoryIn.status).label;
                        this.inventoryIn = inventoryIn;
                    }
                    this.code = null;
                }else{
                    this.$message(result.msg || this.msg('获取失败'));
                }
            });
      },
      playAudio(){
        let audio = this.$refs.audioRef;
        audio.src = this.audioUrl;
        audio.play();
    },
    openDetail(id){
        window.localStorage.setItem("viewDetailIds", id);
        this.$tabs.open("/admin/stock/stock-detail");
    },
    inventoryTraces(id,code){
      this.$refs.inventoryTraceRef.showTracks(id, code);
    },
    inventoryInOutTraces(id,code){
      this.$refs.inventoryOutTraceRef.showTracks(id, code);
    },
    openInventoryInDetail(expCode){
      this.$refs.inventoryInOrderTraceRef.showTracks(expCode);
    },
  }
}
</script>

<style scoped lang="scss">
.trace-wrap{display:flex; justify-content: space-between;}
.trace-box{padding: 10px;}
.detail{margin:10px;}
.detail a{display:inline-block; margin-left: 8px;}
.detail-cell{cursor:pointer; display:inline-block; margin-right:5px;margin-left:8px;}
</style>
